import { render } from "./CommunityEmpowerment.vue?vue&type=template&id=191e9680"
import script from "./CommunityEmpowerment.vue?vue&type=script&lang=js"
export * from "./CommunityEmpowerment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__